import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Row, Col, Button, Modal, Drawer, Tooltip, message, Divider } from 'antd';
import { LeftOutlined, RedoOutlined, UnorderedListOutlined, ToolOutlined } from '@ant-design/icons';
import { isEmpty, find } from 'lodash';
import { Link } from 'react-router-dom';

import {
    loadReportDetails, updateReportDetails, uploadReportFile, loadNextWaitingForApprovalReport, deleteLinkedReportFiles
} from '../actions';
import * as constants from '../constants';
import ReportForm from './ReportForm';

import common from '../../../common';
import currentuser from '../../currentuser';
import core from '../../core';
import globalappstate from '../../globalappstate';
import uistate from '../../uistate';
import companies from '../../companies';
import workflow from '../../workflow';

const { DisplayFormikState } = core;
const { currentUserHasRights } = common;
const { LogbookGrid } = workflow;


class ReportDetails extends Component {

    state = {
        selectedIdReport: '',
        showLogDrawer: false,
        refreshcount: 0,
        test: {},
    }

    UNSAFE_componentWillMount() {
        if (this.props.repId) { //render als popup
            this.setState({
                selectedIdReport: this.props.repId,
            },
                () => this.refreshDetailReport());
        } else { //render as page (url)
            this.setState({
                selectedIdReport: this.props.match.params.repId,
            },
                () => this.refreshDetailReport());
        }
    }

    refreshDetailReport = async (count) => {
        if (count === undefined || count === null) {
            count = 0;
        }
        await this.props.loadReportDetails(this.state.selectedIdReport);
        if (this.props.selectedDetailReport.idReportStatus == common.STATUSES.WaitingForWorkflow && count < 5) {
            setTimeout(this.refreshDetailReport(++count), 3000);
        }
    }

    refreshReport = async => {
        if (this.props.selectedDetailReportIsDirty) {
            if (window.confirm(this.label("UnsavedChanges"))) {
                this.setState(state => ({
                    refreshcount: state.refreshcount + 1,
                }));
                this.props.loadReportDetails(this.state.selectedIdReport);
            }
        } else {
            this.setState(state => ({
                refreshcount: state.refreshcount + 1,
            }));
            this.props.loadReportDetails(this.state.selectedIdReport);
        }
    }

    saveClicked = async (report) => {
        await this.props.updateReportDetails(report);
        await this.refreshDetailReport()
        this.setState({ selectedIdReport: report.idReport })
    }

    savePlusFileClicked = async (report, file) => {
        await this.props.updateReportDetails(report);
        if (file) {
            await this.props.uploadReportFile(file, report.idReport);
            message.success(this.label("UploadSucces"));
        } else {
            await this.props.deleteLinkedReportFiles(report.idReport);
            message.success(this.label("FileDeleteSucces"));
        }
        await this.refreshDetailReport()
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ReportDetails', key);
    }

    navigateBack = async () => {
        let cameFromUrl = this.props.location ? this.props.location.state ? this.props.location.state.from.toLowerCase() : '' : '';
        //console.log('cfu:',cameFromUrl);
        if (this.props.selectedDetailReportIsDirty) {
            if (window.confirm(this.label("UnsavedChanges"))) {
                this.setState(state => ({
                    refreshcount: state.refreshcount + 1,
                }));
                if (this.props.repId) {
                    this.props.onCancel();
                } else {
                    if (cameFromUrl.includes('/approvals/')) {
                        let nextId = await this.props.loadNextWaitingForApprovalReport(this.props.selectedYear);
                        if (nextId && nextId > 0) {
                            message.info(this.label("LoadingNextReportForApproval"))
                            this.props.history.push(`/app/report/${nextId}`, { from: cameFromUrl });
                            this.setState({
                                selectedIdReport: nextId.toString(),
                            },
                                () => this.refreshDetailReport());

                        } else {
                            this.props.history.push(cameFromUrl);
                        }
                    } else {
                        this.props.history.goBack();
                    }
                }
            }
        } else {
            if (this.props.repId) {
                this.props.onCancel();
            } else {
                if (cameFromUrl.includes('/approvals/')) {
                    let nextId = await this.props.loadNextWaitingForApprovalReport(this.props.selectedYear);
                    if (nextId && nextId > 0) {
                        message.info(this.label("LoadingNextReportForApproval"))
                        this.props.history.push(`/app/report/${nextId}`, { from: cameFromUrl });
                        this.setState({
                            selectedIdReport: nextId.toString(),
                        },
                            () => this.refreshDetailReport());
                    } else {
                        this.props.history.push(cameFromUrl);
                    }
                } else {
                    this.props.history.goBack();
                }
            }
        }
    }

    showLogDrawer = () => {
        this.setState({
            showLogDrawer: true,
        });
    };
    onCloseLogDrawer = () => {
        this.setState({
            showLogDrawer: false,
        });
    };

    calculateCurrentUserMutateRights = () => {
        let result = false;
        if (this.props.currentuser.idUser == this.props.selectedDetailReport.idUser) {
            result = this.props.selectedDetailReport.idReportStatus == common.STATUSES.Concept;
            // console.log('exp-user-hasmutate-rights:' ,result);
        }
        return result;
    }

    render() {
        const menuHeight = 45;
        const gridHeight = this.props.contentHeight - menuHeight;
        let cameFromUrl = this.props.location ? this.props.location.state ? this.props.location.state.from.toLowerCase() : '' : '';

        let showform = !isEmpty(this.props.picklists) && !isEmpty(this.props.selectedDetailReport);

        const userHasMutateRights = this.calculateCurrentUserMutateRights();
        const userHasViewReportApprovalFlowRights = find(this.props.currentuser.rights, ['right', common.rights.ViewReportApprovalFlow]) ? true : false;

        return (
            <div className='report' >
                <Row className='main-toolbar' style={{ height: menuHeight }} justify="start" align='middle' gutter={8}>
                    <Col >
                        <Button size='small' type="primary" onClick={this.navigateBack} style={{ marginLeft: 15, marginRight: 15 }} >
                            <LeftOutlined />{this.props.expId ? this.label("Close") : this.label("Back")}
                        </Button>

                        <span className='module-title'>{this.label("ReportDetails")}</span>
                        {userHasViewReportApprovalFlowRights && this.props.selectedDetailReport.workflowInstanceId &&
                            <Tooltip placement="right" title={this.label("ViewWorkflowDetails")}>
                                <a href={`${this.props.currentuser.takenAppUrl}/wfinfo/${this.props.selectedDetailReport.workflowInstanceId}`} style={{ marginLeft: 15 }} target="_blank"><ToolOutlined /></a>
                            </Tooltip>
                        }
                        <Button size='small' onClick={this.refreshReport} style={{ marginLeft: 25 }} >
                            <RedoOutlined />{this.label("RefreshReport")}
                        </Button>
                        {this.props.selectedDetailReport && this.props.selectedDetailReport.workflowInstanceId &&
                            <>
                                <Button size='small' onClick={this.showLogDrawer} style={{ marginLeft: 30 }} >
                                    <UnorderedListOutlined />{this.label("ReportWorkflowLog")}
                                </Button>
                            </>
                        }
                    </Col>
                </Row>

                <Spin size="large" spinning={this.props.loadingDetails}>
                    {showform &&
                        <ReportForm key={`${this.props.selectedDetailReport.idReport}:${this.state.refreshcount}`}
                            cameFromUrl={cameFromUrl}
                            readOnly={!userHasMutateRights} contentheight={gridHeight}
                            datacontext={this.props.selectedDetailReport}
                            contentHeight={this.props.contentHeight} contentWidth={this.props.contentWidth}
                            picklists={this.props.picklists} onSave={this.saveClicked} onSavePlusFile={this.savePlusFileClicked}
                            onRefresh={this.refreshReport} onCancel={this.refreshReport} onRedirect={this.navigateBack} />
                    }
                </Spin>

                <Drawer destroyOnHidden={true} width='50%' title={this.label("ReportWorkflowLog")} placement="left" closable={true} onClose={this.onCloseLogDrawer} open={this.state.showLogDrawer} mask={true} maskClosable={true}>
                    <LogbookGrid workflowInstanceId={this.props.selectedDetailReport.workflowInstanceId} />
                </Drawer>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedDetailReport: state[constants.NAME].selectedDetailReport,
        loadingDetails: state[constants.NAME].loadingDetails,
        contentHeight: state[uistate.constants.NAME].contentheight,
        contentWidth: state[uistate.constants.NAME].contentwidth,
        labels: uistate.selectors.uiLabels(state),
        selectedDetailReportIsDirty: state[constants.NAME].selectedDetailReportIsDirty,
        picklists: globalappstate.selectors.allPicklists(state),
        currentuser: state[currentuser.constants.NAME],
        selectedYear: state[constants.NAME].selectedYear,
    };
}

export default connect(mapStateToProps,
    {
        loadReportDetails, updateReportDetails, uploadReportFile, loadNextWaitingForApprovalReport, deleteLinkedReportFiles
    })(ReportDetails);